import React, { ReactNode, useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation } from "react-router-dom";
import { AppBar } from "../AppBar";
import { BottomNav } from "../BottomNav";
import { Drawer } from "../Drawer";
import { ErrorBoundary } from "../ErrorBoundary";
import { GlobalStyles } from "../../styles/GlobalStyles";
import { YoutubeReconnectPrompt } from "../YoutubeReconnectPrompt";
import { EstablishmentBlockedBanner } from "../EstablishmentBlockedBanner";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  minHeight: 64,
}));

type LayoutProps = {
  children: ReactNode;
};

const BOTTOM_NAV_HEIGHT = 56;

export function Layout({ children }: LayoutProps) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <GlobalStyles />
      <YoutubeReconnectPrompt />
      <Box sx={{ display: "flex", height: { xs: "100dvh", md: "100vh" } }}>
        <AppBar open={open} setOpen={setOpen} showMenu={!isMobile} showTheme showUserMenu />
        {!isMobile && <Drawer open={open} setOpen={setOpen} />}
        <Box component="main" sx={{ flexGrow: 1, display: "flex", flexDirection: "column", overflowX: "hidden" }}>
          <DrawerHeader />
          <EstablishmentBlockedBanner />
          <Box
            key={location.pathname}
            sx={{
              flexGrow: 1,
              p: 2,
              overflow: "auto",
              overflowX: "hidden",
              pb: isMobile ? `${BOTTOM_NAV_HEIGHT + 16}px` : 2,
              animation: "fadeIn 0.2s ease",
            }}
          >
            <ErrorBoundary>
              {children}
            </ErrorBoundary>
          </Box>
        </Box>
        <BottomNav />
      </Box>
    </>
  );
}
